 
         <mat-form-field class="full-width">
            <mat-label> Liste des sociétés <mat-icon  aria-label="help icon">help</mat-icon> </mat-label> 
            <mat-chip-list #chipList aria-label="societe selection">
              <mat-chip
                *ngFor="let societe of selectedSocieteString"
                [selectable]="selectable"
                [removable]="removable"
                (removed)="remove(societe)">
                {{societe}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input
                matTooltip="Sélectionnez les sociétés dans la liste" 
                #societeInput
                [formControl]="societeCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)">
            </mat-chip-list>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let societe of filteredSocietes | async" [value]="societe">
                {{societe}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
   
  
   
   